import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withTranslation  } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"


  
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      height: 140,
      width: 100,
    },
    grid: {
      padding: theme.spacing(10),
    },
    text: {
        paddingTop: 20,
    },
    visible: {
      visibility: 'visible',
    },
    hidden: {
      visibility: 'hidden',
    },
  }));

  const Image = () => {
    const data = useStaticQuery(graphql`
      query {
        placeholderImage: file(relativePath: { eq: "poster.png" }) {
          childImageSharp {
            fluid(maxWidth: 560, maxHeight: 315) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `)
  
    return <Img fluid={data.placeholderImage.childImageSharp.fluid} />
  }

function BlendingBox({t, i18n}) {
    const classes = useStyles();
    let [init, setInit] = React.useState(true)
    let [lng, setLanguage] = React.useState("en")
    let [isVisible, setVisible] = React.useState(true)
    let [videoSource, setVideoSource] = React.useState("video/ReedbasketPromo.mp4")
    React.useEffect(()=>{
      console.log("hompage language is " + i18n.language)
      if (init){
        console.log("Conversations init language is " + i18n.language)
        switch (i18n.language) {
        case "en-GB":
        case "en":
          //setVideoSource("https://www.youtube.com/embed/5DVxSMaTPe4?controls=0&modestbranding=1");
          console.log("setting english video");
          setLanguage("en");
          setVideoSource("video/ReedbasketPromo_en.mp4")
          break;
        case "it":
          //setVideoSource("https://www.youtube.com/embed/Wwmnb2s2Qfg?controls=0&modestbranding=1");
          console.log("setting italian video");
          setLanguage("it");
          setVideoSource("video/ReedbasketPromo.mp4")
          break;
        case "de":
         // setVideoSource("https://www.youtube.com/embed/Wwmnb2s2Qfg?controls=0&modestbranding=1");
          console.log("setting german video");
          setLanguage("de");
          setVideoSource("video/ReedbasketPromo_de.mp4");
          break;
        
        };
        setInit(false);
              
      }
      
  })

    const hideImage = () => {
      alert("boooooo");
      setVisible(true);
      
    }

    return (
            <Grid container style={{paddingTop:50, paddingLeft:40}}>
                <Grid item xs={6} >
                <Typography variant="h2" color="textPrimary"  style={{paddingTop:20}}>
                    {t('secondTitle')}
                </Typography>
                <br/>
                <Typography variant="h5" color="textPrimary">
                    {t('secondContent')}
                </Typography>
                </Grid>
                <Grid item xs={6}>
              {/*
                <div className={isVisible ? classes.hidden : classes.visible} onClick={hideImage}>
                    <Image  width="560" height="315" />
                </div>
              */}
             <div className={isVisible ? classes.visible : classes.hidden}>
                  <iframe  id="video" poster="images/poster.png" width="560" height="315"  src={videoSource} frameBorder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>
                        
                </Grid>
              
            </Grid>

    );
   
}
export default withTranslation('landing') (BlendingBox)